// Delt fargepalett for kunde-ikoner (forbokstav-avatar). Brukes både av
// kundekolonnen og fargevelgeren. Hvis en kunde ikke har valgt farge, utledes en
// stabil farge fra navnet.
export const CUSTOMER_COLORS = [
  "#ef4444",
  "#f97316",
  "#f59e0b",
  "#10b981",
  "#06b6d4",
  "#3b82f6",
  "#6366f1",
  "#8b5cf6",
  "#ec4899",
  "#14b8a6",
];

export const colorForName = (name: string) => {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  }
  return CUSTOMER_COLORS[hash % CUSTOMER_COLORS.length];
};

// Endelig farge for en kunde: valgt farge hvis satt, ellers utledet fra navnet.
export const customerColor = (color: string | null | undefined, name: string) =>
  color || colorForName(name || "?");
